/**
 * aiCreatorAnalytics — thin, safe GA4/dataLayer emitter for AI-creator events.
 *
 * No-ops silently if no analytics layer is present (never throws in the UI).
 * Events (V1): ai_creator_cta_clicked, ai_creator_iframe_loaded, ai_creator_chat_started.
 *
 * These are PAGE-LEVEL (FE) events. chat_started here is a proxy for connect-intent
 * (the modal mounting the iframe), not a true WebRTC session boundary — the Public
 * avatar runs cross-origin, so in-iframe events are not observable in V1.
 */

export function trackAICreator(event, params = {}) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...params });
    }
    // else: no analytics layer loaded yet — silently skip.
  } catch (_) {
    /* analytics must never break the UI */
  }
}
